import { LinkGroupStoryblok, StoryblokComponent } from '@/types/types-storyblok';
import clsx from 'clsx';
import { useState } from 'react';
import Image from 'next/image';
import chevronDownIcon from '@/assets/chevron-down.svg';
import { NavItem } from './navItem';
import { StoryblokStory } from 'storyblok-generate-ts';

export const MobileHeaderNavSection = ({
  links,
  selected,
  isVisible,
  story,
  component,
}: {
  links: LinkGroupStoryblok;
  selected?: boolean;
  isVisible: boolean;
  story: StoryblokStory<StoryblokComponent>;
  component: StoryblokComponent;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <li role="menuitem">
        <button
          aria-hidden={!isVisible}
          aria-expanded={isOpen}
          aria-controls={`mobile-menu-${links._uid}`}
          className={clsx('flex w-full flex-row items-center justify-between p-6', selected && 'bg-brandGreen-100')}
          onClick={() => setIsOpen(!isOpen)}
          tabIndex={!isVisible ? -1 : undefined}
        >
          <div className="flex w-full flex-row items-center justify-start gap-2">
            {selected && <div className="h-2.5 w-2.5 rounded-full bg-elty-green" />}
            <span className="font-medium">{links.title}</span>
          </div>
          <Image aria-hidden className={clsx(!isOpen && 'rotate-180')} src={chevronDownIcon} alt="icona apertura menu" />
        </button>
        <nav
          className={clsx(
            'left-0 top-0 z-10 h-full w-full  transition-all',
            isOpen ? 'max-h-96 opacity-100 duration-700' : 'max-h-0 overflow-hidden opacity-0 duration-300',
          )}
          aria-labelledby={`top-section-label-${links._uid}`}
          aria-hidden={!isOpen}
          id={`mobile-menu-${links._uid}`}
        >
          <ul role="menu" className="flex flex-col gap-5 p-8">
            {links.links.map(
              link =>
                link.component === 'Link' && <NavItem isVisible={isOpen} link={link} key={link._uid} story={story} component={component} />,
            )}
          </ul>
        </nav>
      </li>
    </>
  );
};
